// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "chunk." + {"754":"77019c72d123cab3f9ba","832":"757ea1a41c1cf7c2f9bd","848":"4299f9b266bf7d5e100e","913":"3407713f2db57d683939","916":"acd345cae2536aa8b663"}[chunkId] + ".js";
};